import {
  AuthenticationActions,
  selectMuid,
} from '@meprism/shared/src/redux/authentication/authenticationSlice'
import { AppThunk } from './store'
import { Hub } from 'aws-amplify'
import { addAppListener } from './listenerMiddleware'

export const setUpOauthListener =
  (): AppThunk<Promise<string>> => (dispatch) => {
    let destination = '/dashboard'
    const unsubscribeFromHub = Hub.listen(
      'auth',
      ({ payload: { event, data } }) => {
        if (event === 'customOAuthState' && data) {
          destination = data
        }
      },
    )
    return new Promise((resolve, reject) => {
      dispatch(
        addAppListener({
          actionCreator: AuthenticationActions.addBlockingRequest,
          effect: async (action, listenerApi) => {
            if (action.payload !== 'OAUTH') {
              return
            }
            try {
              // If muid is already populated (e.g. listener registered after Hub event fired),
              // resolve immediately without waiting.
              if (selectMuid(listenerApi.getState())) {
                resolve(destination)
                listenerApi.unsubscribe()
                unsubscribeFromHub()
                listenerApi.dispatch(
                  AuthenticationActions.removeBlockingRequest('OAUTH'),
                )
                return
              }

              // Fallback: If the Amplify signIn Hub event fired before createAmplifyListener
              // was registered, muid won't be set. Manually check the authenticated session
              // and dispatch postConfirmLogin to populate Redux state.
              import('@aws-amplify/auth').then(({ Auth }) => {
                Auth.currentAuthenticatedUser({ bypassCache: true })
                  .then((user) => {
                    import('@meprism/shared/src/redux/authentication/authenticationSlice').then(({ postConfirmLogin }) => {
                      listenerApi.dispatch(postConfirmLogin(user) as any).catch(() => {
                        // Fallback postConfirmLogin failed — condition timer will handle rejection
                      })
                    })
                  })
                  .catch(() => {
                    // No authenticated user yet — condition timer will handle rejection
                  })
              })

              const wasSuccessful = await listenerApi.condition(
                (_, state) => !!selectMuid(state),
                10000,
              )
              if (wasSuccessful) {
                resolve(destination)
              } else {
                reject('/login')
              }
            } catch (error) {
              reject('/login')
            }
            listenerApi.unsubscribe()
            unsubscribeFromHub()
            listenerApi.dispatch(
              AuthenticationActions.removeBlockingRequest('OAUTH'),
            )
          },
        }),
      )

      // Now that we're listening, trigger it
      dispatch(AuthenticationActions.addBlockingRequest('OAUTH'))
    })
  }
